import { render, staticRenderFns } from "./Reset-Password.vue?vue&type=template&id=5679a49e&scoped=true"
import script from "./Reset-Password.vue?vue&type=script&lang=js"
export * from "./Reset-Password.vue?vue&type=script&lang=js"
import style0 from "./Reset-Password.vue?vue&type=style&index=0&id=5679a49e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5679a49e",
  null
  
)

export default component.exports